var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-table", {
    staticClass: "list-table",
    attrs: { items: _vm.data, fields: _vm.fields, responsive: "" },
    scopedSlots: _vm._u([
      {
        key: "cell(date)",
        fn: function(data) {
          return [
            _vm._v(
              "\n        " +
                _vm._s(_vm.moment.unix(data.item.date).format("MMM D Y")) +
                "\n    "
            )
          ]
        }
      },
      {
        key: "cell(salesRep)",
        fn: function(data) {
          return [
            _c(
              "a",
              {
                staticStyle: {
                  cursor: "pointer",
                  color: "blue",
                  "text-decoration": "underline"
                },
                attrs: {
                  href: _vm.$laravelRoute("users.show", data.item.salesRepId)
                }
              },
              [_vm._v("\n            " + _vm._s(data.item.salesRep))]
            )
          ]
        }
      },
      {
        key: "cell(views)",
        fn: function(data) {
          return [
            data.item.views > 0
              ? _c(
                  "a",
                  { staticClass: "link", attrs: { href: _vm.viewsLink(data) } },
                  [
                    _vm._v(
                      "\n            " + _vm._s(data.item.views) + "\n        "
                    )
                  ]
                )
              : [_vm._v(_vm._s(data.item.views))]
          ]
        }
      },
      {
        key: "cell(bids)",
        fn: function(data) {
          return [
            data.item.bids > 0
              ? _c(
                  "a",
                  { staticClass: "link", attrs: { href: _vm.bidLink(data) } },
                  [
                    _vm._v(
                      "\n            " + _vm._s(data.item.bids) + "\n        "
                    )
                  ]
                )
              : [_vm._v(_vm._s(data.item.bids))]
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06713940", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06713940","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/History/HistoryByUser.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-06713940","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/History/HistoryByUser.vue
// module chunks = 0